const MEDIUM_LAYOUT_BREAKPOINT_PX = 768;
const SMALL_VIEW_LAYOUT_BREAKPOINT_PX = 576;

export default {
  data() {
    return {
      currentInnerWidth: null
    };
  },
  computed: {
    isMobile() {
      return this.currentInnerWidth < MEDIUM_LAYOUT_BREAKPOINT_PX;
    },
    isTabletView() {
      return (this.currentInnerWidth > SMALL_VIEW_LAYOUT_BREAKPOINT_PX) &&
        (this.currentInnerWidth < MEDIUM_LAYOUT_BREAKPOINT_PX);
    },
    isLaptopScreenView() {
      return this.currentInnerWidth > MEDIUM_LAYOUT_BREAKPOINT_PX;
    }
  },
  methods: {
    onResize() {
      this.currentInnerWidth = window.innerWidth;
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
  }
};
